import { Button, Col, Drawer, Form, Input, Row, Space, Spin } from "antd";
import { Component } from "react";
import "../styles/general.css";

import { POST, UPDATE } from "../constants/request-type";
import { mailing, user } from "../constants/routes";
import { logo_url, service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import { acceptedProfile, rejectedProfile } from "../mails/mail-type";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

class Check_kyc extends Component {
  state = {
    visible: false,
    firstname: this.props.row.firstname,
    lastname: this.props.row.lastname,
    email: this.props.row.email,
    number: this.props.row.number,
    country: this.props.row.country,
    province: this.props.row.province,
    city: this.props.row.city,
    street: this.props.row.street,
    bio: this.props.row.bio,
    order_timing: this.props.row.order_timing,
    geographical_tag: this.props.row.geographical_tag,
    speciality_tag: this.props.row.speciality_tag,
    availability: this.props.row.availability,
    few_days: this.props.row.few_days,
    planned_days: this.props.row.planned_days,
    fee: this.props.row.fee,
    delivery_fee: this.props.row.delivery_fee,
    pickup_time: this.props.row.pickup_time,
    preview: this.props.row.preview,
    pic1: this.props.row.pic1,
    pic2: this.props.row.pic2,
    pic3: this.props.row.pic3,
    certificate_safety: this.props.row.certificate_safety,
    line: this.props.row.line,
    pickup_instruction: this.props.row.pickup_instruction,
    rejection_message: "",
    list2: [],
    pic: null,
    load: false
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  handleImage = (e) => {
    e.preventDefault();
    return this.setState({ pic: e.target.files[0] });
  };
  getData = async () => {};

  handleAccept = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: user + "/" + "update-user-admin" + "/" + this.props.row._id,
      data: {
        visible: true,
        status: true
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }

    const request_details_mail = {
      type: POST,
      url: service_api,
      route: mailing + "/" + "send-email",
      data: {
        email: this.props.row.email,
        subject: "Profile Live on Panichef",
        html: acceptedProfile({
          fullname: this.props.row.firstname + " " + this.props.row.lastname,
          logo: logo_url
        })
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details_mail);
      logger.log("Envoie terminé");
    } catch (err) {
      
      return openNotificationWithIcon("error", `${err.response.data.message}`);
    }

    openNotificationWithIcon("success", "Super ! vous avez un profile LIVE");

    return setTimeout(() => window.location.reload(), 1000);
  };

  handleRejected = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    if (this.state.rejection_message.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez fournir une raison de rejet"
      );
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: user + "/" + "update-user-admin" + "/" + this.props.row._id,
      data: {
        visible: false,
        status: true
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }

    const request_details_mail = {
      type: POST,
      url: service_api,
      route: mailing + "/" + "send-email",
      data: {
        email: this.props.row.email,
        subject: "Profile Rejection on Panichef",
        html: rejectedProfile({
          fullname: this.props.row.firstname + " " + this.props.row.lastname,
          reason: this.state.rejection_message,
          logo: logo_url
        })
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details_mail);
      logger.log("Envoie terminé");
    } catch (err) {
      
      return openNotificationWithIcon("error", `${err.response.data.message}`);
    }

    openNotificationWithIcon("success", "L'utilisateur sera notifié");

    return setTimeout(() => window.location.reload(), 1000);
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      number,
      firstname,
      lastname,
      email,
      speciality_tag,
      preview,
      pic1,
      pic2,
      pic3,
      bio,
      certificate_safety,
      province,
      city,
      street,
      line,
      pickup_instruction,
      pickup_time,
      rejection_message,
      load
    } = this.state;
    return (
      <>
        <Button type="default" onClick={this.showDrawer}>
          Voir KYC
        </Button>
        <Drawer
          title="Fiche du chef"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Retour
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleRejected(e);
                    }}
                    type="danger"
                    style={{ marginRight: 8 }}
                  >
                    Rejeter
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleAccept(e);
                    }}
                    type="primary"
                  >
                    Accepter
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Col span={24}>
              <Form.Item label="Message en cas de rejet">
                <Input.TextArea
                  type="text"
                  name="rejection_message"
                  placeholder="Laissez la raison du rejet en cas de refus du profile (certains utilisateurs n'ont pas encore terminé le remplissage de leur profile, veuillez accorder du temps pour la finission"
                  onChange={this.handleChange}
                  value={rejection_message}
                />
              </Form.Item>
            </Col>
            <h2
              style={{
                marginTop: 20
              }}
            >
              Profiles
            </h2>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 30,
                padding: 10
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                {preview !== null && (
                  <a target="_blank" href={preview} rel="noreferrer">
                    <img
                      src={preview}
                      alt="banner"
                      style={{
                        width: "100%",
                        height: 150,
                        borderRadius: 10,
                        objectFit: "cover"
                      }}
                    />
                  </a>
                )}
                {preview === null && "Aucune banière ajoutée"}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "center"
                }}
              >
                {pic1 !== null && (
                  <a target="_blank" href={pic1} rel="noreferrer">
                    <img
                      src={pic1}
                      alt="banner"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50,
                        objectFit: "cover"
                      }}
                    />
                  </a>
                )}
                {pic1 === null && <p>Image 1 pas disponible</p>}
                {pic2 !== null && (
                  <a target="_blank" href={pic2} rel="noreferrer">
                    <img
                      src={pic2}
                      alt="banner"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50,
                        objectFit: "cover"
                      }}
                    />
                  </a>
                )}
                {pic2 === null && <p>Image 2 pas disponible</p>}
                {pic3 !== null && (
                  <a target="_blank" href={pic3} rel="noreferrer">
                    <img
                      src={pic3}
                      alt="banner"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50,
                        objectFit: "cover"
                      }}
                    />
                  </a>
                )}
                {pic3 === null && <p>Image 3 pas disponible</p>}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 15,
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center"
                }}
              >
                {certificate_safety.pic !== null && (
                  <a
                    target="_blank"
                    href={certificate_safety.pic}
                    rel="noreferrer"
                  >
                    Voir certifcat
                  </a>
                )}
                {certificate_safety.pic === null && (
                  <p>Certificat pas disponible</p>
                )}
                {certificate_safety.expirity !== null && (
                  <p>
                    Date d'expiration certificat: {certificate_safety.expirity}
                  </p>
                )}
              </div>
            </div>
            <h2>Informations</h2>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Nom">
                  <Input name="text" disabled={true} value={firstname} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Prénom">
                  <Input name="text" disabled={true} value={lastname} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Email">
                  <Input type="text" disabled={true} value={email} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Pays">
                  <Input type="text" disabled={true} value={lastname} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Contact">
                  <Input type="text" disabled={true} value={number} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Type de plats">
                  <Input type="text" disabled={true} value={speciality_tag} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Bio">
                  <Input.TextArea
                    rows={4}
                    type="text"
                    disabled={true}
                    value={bio}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Province">
                  <Input type="text" disabled={true} value={province} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Ville">
                  <Input type="text" disabled={true} value={city} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Rue">
                  <Input type="text" disabled={true} value={street} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Ligne">
                  <Input
                    type="text"
                    disabled={true}
                    value={line === null ? "aucun" : line}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Période de ramassage">
                  <Input type="text" disabled={true} value={pickup_time} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Instruction de ramassage">
                  <Input.TextArea
                    // rows={2}
                    type="text"
                    disabled={true}
                    value={pickup_instruction}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Check_kyc;
